/* eslint-disable no-useless-catch */
// import { FindOneOptions, FindOptions } from './common';

import { serialize } from 'utils';

import { FindOptions } from './common';
import { stockService } from './services';

const pathname = '/inventory-audits';

export const InventoryAuditApi = {
  filter: async (option: any) => {
    let url = `${pathname}/filter`;

    const { entityIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await stockService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStock: async (option: FindOptions) => {
    let url = `${pathname}/stock`;
    const query = serialize(option);
    url += query;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findAuditReason: async () => {
    const url = `${pathname}/audit-reason`;

    try {
      const response = await stockService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductToCreate: async (option: any) => {
    let url = `${pathname}/find-entity-product-to-create`;

    const { excludedEntityProductIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await stockService.post(url, {
        excludedEntityProductIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProductToUpdate: async (id: string, option: any) => {
    let url = `${pathname}/find-entity-product-to-update/${id}`;

    const { excludedEntityProductIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await stockService.post(url, {
        excludedEntityProductIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateInventoryAuditCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await stockService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async () => {
    const url = `${pathname}/generate-code`;
    try {
      const response = await stockService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createInventoryAudit: async (data: CreateInventoryAuditBody) => {
    try {
      const response = await stockService.post(pathname, data);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateInventoryAuditStatus: async (id: string, body: any) => {
    try {
      const response = await stockService.patch(
        `${pathname}/update-status/${id}`,
        body
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateInventoryAudit: async (id: string, data: UpdateInventoryAuditBody) => {
    try {
      const response = await stockService.patch(`${pathname}/${id}`, data);

      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteInventoryAudit: async (id: string) => {
    try {
      const response = await stockService.delete(`${pathname}/${id}`);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CheckDuplicateInventoryAuditCodeQuery {
  code: string;
  entityID?: string;
}

export interface CreateInventoryAuditBody {
  name: string;
  code: string;
  originStockID?: string;
  entityID: string;
}

export interface UpdateInventoryAuditBody {
  name: string;
  code: string;
}
